<div class="cms-search-wrapper"
     data-cy="cms-search-wrapper"
>
  <div (scrolled)="loadNextPage()"
       [infiniteScrollDisabled]="isLastPage || isEmpty"
       [infiniteScrollDistance]="3"
       [infiniteScrollThrottle]="50"
       infinite-scroll
  >
    <div id="mb_cms_search_results"
         #searchResults
    ></div>
  </div>

  <ng-container *ngIf="!results?.searchResults?.length">
    <div data-cy="mb-empty-search-result"
         class="row no-gutters mb-5 mb-cms-line-search-result-wrapper no-text"
    >
      <div class="col-12 col-lg-8 text-center mx-auto my-auto">
        <div class="mt-3 mb-4">
          <strong>{{ 'searchResultItemCms.emptyResultTitle' | mbTranslate }}</strong>
        </div>
        <div>{{ 'searchResultItemCms.emptyResultLineOne' | mbTranslate }}</div>
      </div>
    </div>
  </ng-container>
</div>
